import { Modal } from "antd";
import { InstructionText, Title } from "./styles";
import { ListImoveisFolders } from "../ListImoveisFolders";

interface IProps {
    openModal: boolean;
    handleCloseModal: () => void;
    idImovel: number;
    onSuccess?: () => void
}

export default function ModalAddToFolder({openModal, handleCloseModal, idImovel, onSuccess}: IProps) {
    return (
        <Modal
            centered
            height={'fit-content'}
            width={'50%'}
            className='modal-carrossel'
            open={openModal}
            footer={null}
            zIndex={99999}
            onCancel={handleCloseModal}
            style={{ margin: '2rem' }}
        >
            <div style={{ padding: '1rem' }}>
                <Title>Adicionar imóvel ao seu Perfil</Title>

                <InstructionText>
                    Selecione a pasta que deseja adicionar o imóvel:
                </InstructionText>

                <ListImoveisFolders idImovel={idImovel} handleCloseModal={handleCloseModal} onSuccess={onSuccess && onSuccess}/>

            </div>
        </Modal>
    )
}